import './Modal.css';
import './RoundModal.css';

const RoundModal = ({ children, onClose, onBackdropClick, id, zIndex = 1 }) => (
    <div className="modal-container" style={{ zIndex }} id={id}>
        <div className="modal-backdrop" style={{ zIndex }} onClick={onBackdropClick}></div>
        <div className="round-modal-panel" style={{ zIndex: zIndex + 1 }}>
            {children}
        </div>
    </div>
);

export default RoundModal;
